module.exports = __webpack_public_path__ + "img/nature-4.9e8aeb80.jpg";